import React, { useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components/macro';
import Waypoint from '../Waypoint';
// import { retinaImage } from 'polished';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

export const MediaBlock = styled.div`
  margin: ${props => (props.margin ? '0' : '2em')} auto;
  padding-bottom: ${props => (props.isLastItem ? '2em' : 0)};
`;

const ImageBlock = styled.div`
  // width: 100%;
  max-width: 72rem;
  margin: 0 auto;

  /** Hack for the image enlarger plugin setting our div to inline-block */
  .EnlargedImage__container {
    display: block !important;
  }
`;

const drawLine = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

/** Setup animation durations & delays to be used by svg image */
export const animationTiming = () => {
  let styles = '';
  let interval = 1600;

  for (let i = 2; i < 6; i++) {
    styles += `
      &:nth-child(${i}n) {
        animation-duration: 2000ms;
        animation-delay: ${(i - 2) * 500}ms;

        // animation-duration: ${interval}ms;
        // animation-delay: ${i * 400}ms;
      }
    `;

    interval *= 1.4;
  }

  return css`
    ${styles}
  `;
};

const StyledSvg = styled.div`
  width: ${props => props.size};
  margin: 0 auto;
  ${({ alignment }) =>
    alignment && alignment.toLowerCase() === 'left'
      ? css`
          margin-left: 0;
        `
      : alignment && alignment.toLowerCase() === 'right'
      ? css`
          margin-right: 0;
        `
      : null}

  svg {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    ${props =>
      !!props.isIe11 && !!props.svgHeight && `height: ${props.svgHeight}px;`};
  }

  polyline,
  line {
    ${props =>
      !props.isIe11 &&
      props.animateLines &&
      'stroke-dasharray: 1000; stroke-dashoffset: 1000;'};
    ${props =>
      !props.isIe11 &&
      props.shouldAnimate &&
      css`
        animation: ${drawLine} 2s linear forwards;
      `};
  }

  path {
    ${props =>
      !props.isIe11 &&
      props.animateLines &&
      'stroke-dasharray: 1000; stroke-dashoffset: 1000;'};
    ${props =>
      !props.isIe11 &&
      props.shouldAnimate &&
      css`
        animation: ${drawLine} 2s linear forwards;
      `};

    ${animationTiming};
  }

  polygon.arrow-point {
    opacity: 0;
    transition: opacity 0.4s ease 1.4s;

    ${props =>
      !props.isIe11 &&
      props.shouldAnimate &&
      css`
        opacity: 1;
      `};
  }
`;

const StyledImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

const Media = ({ src, fields, isNested, className, ...rest }) => {
  const {
    image,
    customWidth,
    alignment,
    removeContainer,
    animateLines,
    magnify,
  } = fields;
  const [svg, getSvg] = useState('');
  const [shouldAnimate, setAnimate] = useState(false);
  // const [zoomed, setZoomed] = React.useState(false);

  useEffect(() => {
    async function fetchData() {
      await fetch(image)
        .then(response => response.text())
        .then(body => getSvg(body));
    }
    image && fetchData();
  }, [image]);

  // const alt = image.fields && (image.fields.description || image.fields.title);

  const isIe11 = !!(window.navigator.userAgent.indexOf('Trident/') > -1);

  /** IE fallback to add a height to svg elements */
  const svgHeightMatch = isIe11 && svg && svg.match(/height="(\d+\.?\d.)"/);
  const svgHeight =
    svgHeightMatch && svgHeightMatch.length && svgHeightMatch[1];

  return (
    <Waypoint
      topOffset="0"
      bottomOffset="25%"
      onEnter={() => setAnimate(true)}
      onLeave={() => setAnimate(false)}
    >
      <ImageBlock
        margin={removeContainer}
        isLastItem={rest.index + 1 === rest.numberOfBlocks}
      >
        {animateLines && (
          <StyledSvg
            // alt={alt}
            alignment={alignment}
            size={customWidth}
            animateLines={animateLines}
            shouldAnimate={shouldAnimate}
            dangerouslySetInnerHTML={{ __html: svg }}
            isIe11={isIe11}
            svgHeight={svgHeight}
          />
        )}
        {magnify && (
          <Zoom wrapStyle={{ display: 'block' }}>
            <StyledImage
              src={image}
              size={customWidth}
              // alt={alt}
              // alignment={alignment}
              // size={width}
              className={className}
            ></StyledImage>
          </Zoom>
        )}
        {!animateLines && !magnify && (
          <StyledImage
            src={image}
            size={customWidth}
            // alt={alt}
            // alignment={alignment}
            // size={width}
            className={className}
          ></StyledImage>
        )}
      </ImageBlock>
    </Waypoint>
  );
};

Media.defaultProps = {
  fields: {
    width: '100%',
    justifyContent: 'flex-start',
    magnify: false,
  },
  isNested: true,
};

export default Media;
